import React from 'react';
import { func, object, bool, number, string } from 'prop-types';

import ApplyCoupon from '../../../atoms/apply-coupon';
import ShowAppliedCoupon from '../../../atoms/show-applied-coupon';

import './discount-coupon.m.css';

class DiscountCoupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showApplyCoupon: false
    };

    this.showApplyCoupon = this.showApplyCoupon.bind(this);
  }

  componentDidMount() {
    if (this.props.theme) {
      this.setState({ showApplyCoupon: true });
    }
  }

  showApplyCoupon(e) {
    e.preventDefault();
    this.setState({ showApplyCoupon: true });
  }

  render() {
    const { selectedPlanId, setAppliedCoupon, appliedCoupon, resetCouponState } = this.props;

    if (appliedCoupon && appliedCoupon.valid) {
      return (
        <ShowAppliedCoupon resetCouponState={resetCouponState} appliedCoupon={appliedCoupon} />
      );
    }

    if (this.state.showApplyCoupon) {
      return (
        <ApplyCoupon
          theme={this.props.theme}
          selectedPlanId={selectedPlanId}
          setAppliedCoupon={setAppliedCoupon}
          isLoading={this.props.isLoading}
          couponCode={this.props.couponCode}
          invalid={this.props.invalid}
          subscriptionExist={this.props.subscriptionExist}
          handleInvalidCoupon={this.props.handleInvalidCoupon}
          clearCoupon={this.props.clearCoupon}
          onChangeCouponInput={this.props.onChangeCouponInput}
          setLoading={this.props.setLoading}
          disablePlanSelection={this.props.disablePlanSelection}
          enablePlanSelection={this.props.enablePlanSelection}
          disableProceedButton={this.props.disableProceedButton}
          enableProceedButton={this.props.enableProceedButton}
        />
      );
    }

    return (
      <div styleName="wrapper">
        <a href="#" styleName="ask-coupon" data-testid="ask-coupon" onClick={this.showApplyCoupon}>
          Have a discount coupon?
        </a>
      </div>
    );
  }
}

DiscountCoupon.propTypes = {
  setAppliedCoupon: func.isRequired,
  selectedPlanId: number.isRequired,
  resetCouponState: func,
  appliedCoupon: object,
  theme: string,
  isLoading: bool.isRequired,
  invalid: bool.isRequired,
  subscriptionExist: bool.isRequired,
  couponCode: string.isRequired,
  setLoading: func.isRequired,
  handleInvalidCoupon: func.isRequired,
  onChangeCouponInput: func.isRequired,
  disablePlanSelection: func,
  enablePlanSelection: func,
  enableProceedButton: func,
  disableProceedButton: func,
  clearCoupon: func
};

export default DiscountCoupon;
